import Hero from "@/components/Hero";
import Services from "@/components/Services";
import OurWork from "@/components/OurWork";
import CtaBand from "@/components/CtaBand";
import Seo from "@/components/Seo";

export default function Home() {
  return (
    <>
      <Seo
        title="Aluminium Fabrication & Boat Modifications Albany WA | SAMI FAB"
        description="SAMI FAB provides aluminium welding, boat modifications, marine maintenance, kit boat builds, toolboxes, canopies, trailers and caravan accessories in Albany and the Great Southern."
        keywords="aluminium fabrication Albany WA, boat modifications Albany, marine fabrication, aluminium welding Albany, boat maintenance, kit boat builds, custom boat trailers, ute canopies, aluminium toolboxes, caravan accessories"
        path="/"
      />
      <Hero />
      <Services />
      <OurWork />
      <CtaBand />
    </>
  );
}
